import React, { useContext } from 'react'
import ReactDom from 'react-dom';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import { 
    BUTTON_STYLES, 
    LINK_STYLES
} from '../constants/styles';
import { AuthContext } from './context/authContext';
import { GET_ANNOTATION } from '../utils/queries';

const Annotation = ({ book, chapter, verse }) => {
    const { loading, error, data } = useQuery(GET_ANNOTATION, {
        variables: { book, chapter, verse }
    })

    if (loading) return <p>loading</p>;
    if (error) {
      return (
        <>
        <h2>error:</h2>
        <p>database is inaccessable right now</p>
        <p>check internet connection or go to about page to report an issue</p>
        </>
      );
    }

    return (
        <>
        <h2>context annotations:</h2>
            {data.getAnnot.map(a => (
            <>
            <p key={a.username}>{a.body}</p>
            <p key={a.body}>by: {a.username}</p>
            </>
            ))}  
        </>
    )
}

const Modal = ({ 
        open, 
        children, 
        onClose,
        book,
        chapter,
        verse
     }) => {

    const { user } = useContext(AuthContext)
    
    if(!open) return null;

    

        return ReactDom.createPortal(
          <>
            <div className="modal-overlay" onClick={onClose} />
            <div className="modal modal-fade">
              {children}
              <Annotation book={book} chapter={chapter} verse={verse} />
              {user ? 
              <button style={BUTTON_STYLES}>
                <Link to="/annotations" style={LINK_STYLES}>
                  submit annotation
                </Link>
              </button>
              : 
              <button style={BUTTON_STYLES}>
                <Link to="/login" style={LINK_STYLES}>
                  login to add annotation
                </Link>
              </button>
              }
              
            </div>
          </>,
          document.getElementById("portal")
        );
}

export default Modal;
